import _ from "underts";
const planComptable = {
    recettes: {
        706900: "honoraires encaissés non soumis à TVA",
        708000: "gain divers",
    },
    dépenses: {
        600000: "achats",
        606100: "chauffage, eau, gaz, électricité",
        606300: "petit outillage",
        606301: "consommable",
        606302: "achats prothèses",
        606303: "instruments",
        606321: "implants consommables",
        606322: "implants prothèses",
        606323: "implants instruments",
        606331: "ortho consommables",
        606332: "ortho prothèses",
        606333: "ortho instruments",
        606400: "fournitures de bureau",
        613200: "loyers et charges locatives",
        613500: "location de matériel et mobilier",
        615000: "entretien et réparations",
        616000: "primes d'assurance",
        618100: "documentation",
        618500: "formation professionnelle",
        619000: "débours payés",
        621100: "personnel intérimaire",
        622600: "honoraires versés non rétrocédés",
        622650: "honoraires versés rétrocédés",
        622700: "frais d'actes et de contentieux",
        623800: "autres frais divers de gestion",
        625100: "frais de voyages et de séjours",
        625200: "frais de véhicules",
        625300: "autres frais de déplacements",
        625600: "frais de réceptions, congrès",
        626000: "frais de télécommunication",
        626100: "frais d'affranchissement",
        628100: "cotisations syndicales et professionnelles, CURPS",
        633300: "cotisation formation professionnelle CFP",
        635120: "cotisations foncières des entreprises CFE",
        635125: "cotisations valeur ajoutée des entreprises CVAE",
        635800: "autres impôts et taxes",
        637800: "csg déductible",
        641000: "salaires nets payés",
        645000: "charges sociales sur salaires",
        645800: "autres charges sociales sur salaires",
        646000: "cotisations personnelles exploitant",
        646100: "cotisations personnelles Madelin",
        647000: "assurance vieillesse",
        647100: "assurance maladie",
        647200: "allocations familiales",
        647300: "autres charges sociales personnelles obligatoires",
        647350: "autres charges sociales personnelles facultatives",
        647500: "médecine du travail",
        660000: "frais financiers",
        671200: "pertes diverses",
    },
    autres: {
        108000: "apports personnels",
        108001: "dépenses non décaissées par la trésorerie",
        108100: "prélèvements personnels",
        160000: "emprunts",
        200000: "acquisition d'immobilisation",
        209000: "cession d'immobilisation",
        512000: "banque",
        530000: "caisse",
        580000: "virements internes",
    },
};
const allComptes = Object.values(planComptable).reduce((acc, curr) => ({ ...acc, ...curr }), {});
const consolidatedComptesNames = _.sortBy(Object.values(planComptable)
    .map((obj) => Object.entries(obj))
    .flat(), ([key, _value]) => key).map(([key, value]) => key + " " + value);
export default planComptable;
export { allComptes, consolidatedComptesNames };
//# sourceMappingURL=planComptable.js.map